/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useRef, useState } from 'react';
import CameraCapture from '../../components/CameraCapture';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import FileLoader from '../../components/FileLoader';
import { dataService } from '../../services/data.service';
import ApplicationContext from '../../context/ApplicationContext';
import InsuranceHeader from './InsuranceHeader';
import BackButton from '../../components/Button/BackButton';
import NextButton from '../../components/Button/NextButton';
import { insuranceLanguageContent } from './InsuranceLanguageContent';
import { backNextLanguageContent } from '../../components/Button/backNextLanguageContent';

function TakeInsuranceBackPhoto(props) {
    const { handlePage, insurances, insuranceIndex, sessionData, setLoading, selectedLanguage } = useContext(ApplicationContext);
    const videoRef = useRef(null);
    const [insuranceBackImage, setInsuranceBackImage] = useState('');
    const [imageLoading, setImageLoading] = useState(true);
    const [loader, setLoader] = useState(false);
    const [insuranceId, setInsuranceId] = useState('');

    const handleSubmitImage = async() => {
        setLoader(true);
        let payload = {
            "insurance_back_image": insuranceBackImage,
            "upload_type_back": "capture",
            "process_ocr": false
        }
        if(insuranceId) {
            if(insurances[insuranceIndex] && insurances[insuranceIndex].process_ocr === false) {
                // do nothing
            } else if(insurances[insuranceIndex].insurance_back_image !== insuranceBackImage || insurances[insuranceIndex].carrier === '') {
                payload = {
                    ...payload,
                    "process_ocr": true
                }
            }
            dataService.updateInsuranceData(sessionStorage.getItem('session'), payload, insuranceId).then((res) => {
                if(res.error === false) {
                    setLoader(false);
                    setLoading(true);
                    handlePage('insurance_details', '', `${insuranceIndex}`, sessionData['review'] === 'previous' ? 'previous' : '');
                }
            });
        } else {
            payload = {
                ...payload,
                "process_ocr": true
            }
            dataService.addInsuranceData(sessionStorage.getItem('session'), payload).then((res) => {
                if(res.error === false) {
                    setLoader(false);
                    setLoading(true);
                    handlePage('insurance_details', '', `${insuranceIndex}`, sessionData['review'] === 'previous' ? 'previous' : '');
                }
            });
        }
    }

    useEffect(() => {
        if(insurances.length > 0) {
            if(insurances[insuranceIndex] && insurances[insuranceIndex].upload_type_back === 'capture' && insurances[insuranceIndex].insurance_back_image) {
                setInsuranceBackImage(insurances[insuranceIndex].insurance_back_image);
                setInsuranceId(insurances[insuranceIndex]._id);
                setImageLoading(false);
            } else {
                setImageLoading(false);
                if(insurances[insuranceIndex]) {
                    setInsuranceId(insurances[insuranceIndex]._id);
                }
            }
        } else {
            setImageLoading(false);
        }
    }, [insurances]);

    const handleBackFromUpload = () => {
        if (videoRef.current && videoRef.current.srcObject) {
            const tracks = videoRef.current.srcObject.getTracks();
            tracks.forEach((track) => track.stop());
        }
        setInsuranceBackImage('');
        handlePage('take_insurance_front_image', '', '', sessionData.insurance_index, sessionData['review'] === 'previous' ? 'previous' : '');
    }

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-auto'>
            <InsuranceHeader />
            <div className='p-[8px] overflow-x-hidden overflow-y-auto options-height Form-scroll mt-[18px]'>
                <div className='mx-[12px] '>
                    <div>
                        {insuranceLanguageContent['take-back-photo'][selectedLanguage]}
                        <div className='mt-[32px]'>
                            {imageLoading 
                                ? <FileLoader /> : 
                                <CameraCapture id="insurance"
                                    cameraTitle={<p className='bg-[#F2F2F2] px-[5px] text-[11px]'>{insuranceLanguageContent['insurance'][selectedLanguage]}<b className='text-primary'> {backNextLanguageContent['back'][selectedLanguage]}</b></p>} imageLoading={imageLoading} 
                                    setImageLoading={setImageLoading} videoRef={videoRef} filePath="patients/id-capture" capturedImage={insuranceBackImage} 
                                    setCapturedImage={setInsuranceBackImage} />}
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex mb-[24px] justify-between mx-[16px] w-auto fold-gap gap-[12px] '>
                <BackButton disabled={loader || imageLoading} handleClick={() => handleBackFromUpload()} backType="previous" />
                <NextButton disabled={insuranceBackImage === '' || loader || imageLoading} handleClick={() => handleSubmitImage()} loader={loader} />
            </div>
        </AnimatedPageFade>
    );
}

export default TakeInsuranceBackPhoto;